import { createContext, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { Decrypt_Id_Name } from '@/Components/Common/Utility';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import MonitorServices from '@/CADServices/APIs/monitor';
import MasterTableListServices from '@/CADServices/APIs/masterTableList';
import { setupSignalRHandlers } from '@/CADServices/signalRService';
import BoloServices from '@/CADServices/APIs/bolo';

export const IncidentContext = createContext();

const IncidentData = ({ children }) => {
  const dispatch = useDispatch();
  const [loginAgencyID, setLoginAgencyID] = useState();
  const [loginPinID, setLoginPinID] = useState();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const [isOnCAD, setIsOnCAD] = useState(false);
  const [incidentData, setIncidentData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [allResourcesData, setAllResourcesData] = useState([]);
  const [CommentsData, setCommentsData] = useState([]);
  const [incidentCount, setIncidentCount] = useState([]);
  const [offset, setOffset] = useState('');
  const [incID, setIncID] = useState(null);
  const [checkReadUnReadBoloData, setCheckReadUnReadBoloData] = useState(null);
  const [incidentAction, setIncidentAction] = useState('ALL');
  const getIncidentListKey = `/CAD/Monitor/MonitorIncidentsView`;
  // const isDashboardPage = window.location.pathname === '/cad/dashboard-page';
  const isDashboardPage = true
  const { data: getIncidentData, isSuccess: isFetchIncidentList, refetch: incidentRefetch, error: getIncidentError } = useQuery(
    [getIncidentListKey, { AgencyID: loginAgencyID, Action: incidentAction }],
    MonitorServices.getIncidentsView,
    {
      refetchOnWindowFocus: false,
      enabled: !!loginAgencyID && isDashboardPage,
      onError: (error) => {
        if (error?.response?.status === 400) {
          console.error("No Data Available", error?.response?.data?.Message);
          setIncidentData([]);
        } else {
          setIncidentData([]);
          console.error("An error occurred:", error);
        }
      },
    }
  );

  useEffect(() => {
    if (getIncidentData && isFetchIncidentList) {
      const parsedData = JSON.parse(getIncidentData?.data?.data);
      const data = parsedData?.Table1 || [];
      const countData = parsedData?.Table || [];
      setIncidentData(data);
      setIncidentCount(countData?.[0]);
    } else {
      setIncidentData([]);
      setIncidentCount([]);
    }
    if (getIncidentError) {
      setIncidentData([]);
      setIncidentCount([]);
    }
  }, [getIncidentData, isFetchIncidentList, getIncidentError]);

  const assignedIncidentData = useMemo(
    () => (incidentData ?? []).filter((item) => item?.IncidentID != null && item?.IncidentID !== ''),
    [incidentData]
  );
  const unassignedIncidentData = useMemo(
    () => (incidentData ?? []).filter((item) => item?.IncidentID == null || item?.IncidentID === ''),
    [incidentData]
  );
  const access_token = sessionStorage.getItem("access_token");

  const getOffSetTimeKey = `/CAD/CallTakerIncident/GetOffSetTime`;
  const { isSuccess: isFetchGetOffSetTime, refetch: getOffSetTimeRefetch } = useQuery(
    [getOffSetTimeKey, { AgencyID: loginAgencyID }],
    MonitorServices.getOffSetTime,
    {
      refetchOnWindowFocus: false,
      retry: 0,
      enabled: !!loginAgencyID && access_token !== "undefined",
      onSuccess: (res) => {
        if (res?.status === 200) {
          const data = res?.data?.offset;
          setOffset(data);
        } else {
          console.error("Error parsing name:");
          return;
        }
      },
    }
  );

  const getCheckReadUnReadBoloKey = `/CAD/Bolo/CheckReadUnReadBolo`;
  const { data: getCheckReadUnReadBoloData, isSuccess: isFetchCheckReadUnReadBolo, refetch: getCheckReadUnReadBoloRefetch } = useQuery(
    [getCheckReadUnReadBoloKey, { AgencyID: loginAgencyID, PINID: loginPinID }],
    BoloServices.getCheckReadUnReadBolo,
    {
      refetchOnWindowFocus: false,
      retry: 0,
      enabled: !!loginAgencyID && !!loginPinID && access_token !== "undefined" && isDashboardPage,
    }
  );

  useEffect(() => {
    if (getCheckReadUnReadBoloData && isFetchCheckReadUnReadBolo) {
      const data = JSON.parse(getCheckReadUnReadBoloData?.data?.data)?.Table;
      setCheckReadUnReadBoloData(data?.[0]?.IsUnreadFlag);
    } else {
      setCheckReadUnReadBoloData(null);
    }
  }, [getCheckReadUnReadBoloData, isFetchCheckReadUnReadBolo]);

  useEffect(() => {
    if (loginAgencyID && access_token !== "undefined") {
      getOffSetTimeRefetch();
    }
  }, [loginAgencyID, access_token, getOffSetTimeRefetch]);

  const isFetchAssignedIncidentList = isFetchIncidentList;
  const isFetchUnassignedIncidentList = isFetchIncidentList;
  const assignedIncidentListRefetch = incidentRefetch;
  const unassignedIncidentListRefetch = incidentRefetch;


  const getResourceListKey = `CAD/Monitor/MonitorResourceView`;

  const { data: getResourceData, isSuccess: isFetchResourceList, refetch: resourceRefetch, error: getResourceError } = useQuery(
    [getResourceListKey, { AgencyID: loginAgencyID }],
    MonitorServices.getResourceView,
    {
      refetchOnWindowFocus: false,
      enabled: !!loginAgencyID && isDashboardPage,
      onError: (error) => {
        if (error?.response?.status === 400) {
          console.error("No Data Available", error?.response?.data?.Message);
          setResourceData([]);
        } else {
          setResourceData([]);
        }
      }
    }
  );

  useEffect(() => {
    if (getResourceData && isFetchResourceList) {
      const parsedData = JSON.parse(getResourceData?.data?.data);
      const data = parsedData?.Table;
      if (JSON.stringify(data) !== JSON.stringify(resourceData)) {
        setResourceData(data);
      }
      setResourceData(data);
    } else {
      setResourceData([]);
    }
    if (getResourceError) {
      setResourceData([]);
    }
  }, [getResourceData, isFetchResourceList, getResourceError]);


  const getAllResourcesKey = `/CAD/MasterResource/GetAllActiveResources`;
  const { data: getAllResourcesData, isSuccess: isFetchAllResourcesData, refetch: getAllResourcesRefetch, error: getAllResourcesError } = useQuery(
    [getAllResourcesKey, { AgencyID: loginAgencyID }],
    MasterTableListServices.getAllResources,
    {
      refetchOnWindowFocus: false,
      enabled: !!loginAgencyID && isDashboardPage,
      onError: (error) => {
        if (error?.response?.status === 400) {
          console.error("No Data Available", error?.response?.data?.Message);
          setAllResourcesData([]);
        } else {
          setAllResourcesData([]);
        }
      }
    }
  );

  useEffect(() => {
    if (getAllResourcesData && isFetchAllResourcesData) {
      const parsedData = JSON.parse(getAllResourcesData?.data?.data);
      const data = parsedData?.Table;
      if (JSON.stringify(data) !== JSON.stringify(allResourcesData)) {
        setAllResourcesData(data);
      }
      setAllResourcesData(data);
    } else {
      setAllResourcesData([]);
    }
    if (getAllResourcesError) {
      setAllResourcesData([]);
    }
  }, [getAllResourcesData, isFetchAllResourcesData, getAllResourcesError]);


  const getCommentsKey = `/CAD/DispatcherComments/GetData_Comments`;
  const { refetch: refetchGetComments } = useQuery(
    [getCommentsKey, { IncidentID: incID }],
    MonitorServices.GetComments,
    {
      refetchOnWindowFocus: false,
      enabled: !!incID,
      retry: 0,
      onSuccess: (data) => {
        if (data?.data?.Data?.length === 0) {
          setCommentsData([]);
          return;
        } else {
          try {
            const parsedData = JSON.parse(data?.data?.data)?.Table || [];
            setCommentsData(parsedData);
          } catch (error) {
            console.error("Error parsing name:", error);
            setCommentsData([]);
          }
        }
      },
      onError: (error) => {
        setCommentsData([]);
        if (error?.response?.data?.Code === 400) {
          console.warn("No Data Available : GetData_Comments", error?.response?.data?.Message);
        } else {
          console.warn("An error occurred: GetData_Comments", error);
        }
      }
    }
  );


  useEffect(() => {
    const enc = sessionStorage.getItem('UniqueUserID');
    const uniqueId = enc ? Decrypt_Id_Name(enc, 'UForUniqueUserID') : '';
    if (!uniqueId) return;
    const hasAgency =
      localStoreData &&
      typeof localStoreData === 'object' &&
      !Array.isArray(localStoreData) &&
      localStoreData.AgencyID;
    if (!hasAgency) {
      dispatch(get_LocalStoreData(uniqueId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot hydrate; omit localStoreData to avoid re-dispatch when API sets []
  }, [dispatch]);

  useEffect(() => {
    if (
      localStoreData &&
      typeof localStoreData === 'object' &&
      !Array.isArray(localStoreData)
    ) {
      setLoginAgencyID(localStoreData?.AgencyID);
      setLoginPinID(localStoreData?.PINID);
    }
  }, [localStoreData]);

  useEffect(() => {
    if (window.location.pathname.includes('/cad/')) {
      incidentRefetch();
      resourceRefetch();
      getAllResourcesRefetch();
    }
  }, [incidentRefetch, resourceRefetch, getAllResourcesRefetch, isOnCAD]);

  useEffect(() => {
    const resourceRefetchForDashboard = () => {
      if (window.location.pathname === '/cad/dashboard-page') {
        return resourceRefetch();
      }
      return Promise.resolve();
    };
    // Set up SignalR handlers with the context functions
    setupSignalRHandlers(incidentRefetch, resourceRefetchForDashboard);
  }, [incidentRefetch, resourceRefetch]);

  return (
    <IncidentContext.Provider
      value={{
        incidentData,
        incidentCount,
        incidentAction,
        setIncidentAction,
        isFetchIncidentList,
        incidentRefetch,
        resourceData,
        isFetchResourceList,
        resourceRefetch,
        assignedIncidentData,
        isFetchAssignedIncidentList,
        assignedIncidentListRefetch,
        unassignedIncidentData,
        isFetchUnassignedIncidentList,
        unassignedIncidentListRefetch,
        CommentsData,
        refetchGetComments,
        incID,
        setIncID,
        offset,
        setIsOnCAD,
        allResourcesData,
        isFetchAllResourcesData,
        getAllResourcesRefetch,
        checkReadUnReadBoloData,
        getCheckReadUnReadBoloRefetch
      }}
    >
      {children}
    </IncidentContext.Provider>
  );
};

export default IncidentData;
